import { add } from 'date-fns';
import { format, toZonedTime } from 'date-fns-tz';
import { hr, enGB, de, sl, it, nl } from 'date-fns/locale';

export function formatDate(date: any, dateFormat: string = 'dd. MMM') {
  const { lang } = useLanguage();
  // locales mapper
  const localesMapper = { 'en': enGB, 'de': de, 'it': it, 'nl': nl, 'sl': sl, 'hr': hr }
  const zonedDate = toZonedTime(new Date(date), 'Europe/Zagreb');
  return format(zonedDate, dateFormat, { locale: localesMapper[lang.value] || enGB, timeZone: 'Europe/Zagreb' });
}

export function twoYearsFromToday() {
  const today = new Date();
  return add(today, { years: 2 });
}